import React from 'react';
import PropTypes from 'prop-types';
import FieldCustomSelect from '../fields/FieldCustomSelect';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';

const FORM_LABEL = {
    'ParentID:Reseller': getTranslation('FIELD.RESELLER'),
    'ParentID:Wholesaler': getTranslation('FIELD.WHOLESALER'),
};

const getSupplierGroupItemsDropdown = (list) => {
    return list.map((item) => {
        let name = '';

        if (item.BusinessName) {
            name += item.BusinessName;
        } else {
            if (item.FirstName) {
                name += ' ' + item.FirstName;
            }
            if (item.Surname) {
                name += ' ' + item.Surname;
            }
        }

        return {
            label: name.trim(),
            value: Number(item.ID),
        };
    });
};

function SupplierSection(props) {
    const {
        fieldRefs,
        handleFormUpdate,
        updateField,
        isLoading,
        formData,
        existingSupplierList,
        newSupplierList,
        memberType,
        isDisabled,
    } = props;

    // Effects
    // --------------------

    // Functions
    // --------------------

    const getResellerDropdown = () => {
        let list = [
            {
                label:
                    memberType == 'retail-customer'
                        ? getTranslation('FIELD.PLACEHOLDER.SELECT_RESELLER')
                        : getTranslation('FIELD.PLACEHOLDER.SELECT_WHOLESALER'),
                value: '',
            },
        ];

        if (
            typeof existingSupplierList != 'undefined' &&
            existingSupplierList.length
        ) {
            list = [
                ...list,
                {
                    label:
                        memberType == 'retail-customer'
                            ? getTranslation(
                                  'FIELD.GROUP.RECENTLY_USED_RESELLER'
                              )
                            : getTranslation(
                                  'FIELD.GROUP.RECENTLY_USED_WHOLESALER'
                              ),
                    options: getSupplierGroupItemsDropdown(
                        existingSupplierList
                    ),
                },
            ];

            // list = [...list, ...getSupplierGroupItemsDropdown(existingSupplierList)];
        }

        if (typeof newSupplierList != 'undefined' && newSupplierList.length) {
            list = [
                ...list,
                {
                    label:
                        memberType == 'retail-customer'
                            ? getTranslation('FIELD.GROUP.OTHER_RESELLER')
                            : getTranslation('FIELD.GROUP.OTHER_WHOLESALER'),
                    options: getSupplierGroupItemsDropdown(newSupplierList),
                },
            ];

            // list = [...list, ...getSupplierGroupItemsDropdown(newSupplierList)];
        }

        return list;
    };

    return (
        <React.Fragment>
            <div className='select-delivery-supplier-modal__section'>
                <div className='row'>
                    <div className='col-xs-12 col-sm-6'>
                        <div className='select-delivery-supplier-modal__info'>
                            {memberType == 'retail-customer' ? (
                                <React.Fragment>
                                    <h4 className='heading heading--h4'>
                                        <LocalizedMessage
                                            id={
                                                'SELECT_DELIVERY_SUPPLIER_MODAL.RESELLER_HEADING'
                                            }
                                        />
                                    </h4>
                                    <div className='text-box text-box--small text-box--grey'>
                                        <p>
                                            <LocalizedMessage
                                                id={
                                                    'SELECT_DELIVERY_SUPPLIER_MODAL.RESELLER_DESCRIPTION'
                                                }
                                            />
                                        </p>
                                    </div>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <h4 className='heading heading--h4'>
                                        <LocalizedMessage
                                            id={
                                                'SELECT_DELIVERY_SUPPLIER_MODAL.WHOLESALER_HEADING'
                                            }
                                        />
                                    </h4>
                                    <div className='text-box text-box--small text-box--grey'>
                                        <p>
                                            <LocalizedMessage
                                                id={
                                                    'SELECT_DELIVERY_SUPPLIER_MODAL.WHOLESALER_DESCRIPTION'
                                                }
                                            />
                                        </p>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                    <div className='col-xs-12 col-sm-6'>
                        <div className='select-delivery-supplier-modal__fields'>
                            <FieldCustomSelect
                                required
                                ref={(r) => (fieldRefs.ParentID = r)}
                                className='field--filled'
                                disabled={isDisabled}
                                isDisabled={isDisabled}
                                isMulti={false}
                                isSearchable={true}
                                isClearable={true}
                                limit={1}
                                isLoading={isLoading.supplier}
                                label={
                                    memberType == 'retail-customer'
                                        ? FORM_LABEL['ParentID:Reseller']
                                        : FORM_LABEL['ParentID:Wholesaler']
                                }
                                animatedLabel={
                                    memberType == 'retail-customer'
                                        ? FORM_LABEL['ParentID:Reseller']
                                        : FORM_LABEL['ParentID:Wholesaler']
                                }
                                name='ParentID'
                                options={getResellerDropdown()}
                                value={formData.ParentID || ''}
                                onChange={(name, value) =>
                                    updateField(name, Number(value))
                                }
                            />
                            {isDisabled === true && (
                                <span className='field-instruction'>
                                    {memberType == 'retail-customer' ? (
                                        <LocalizedMessage
                                            id={
                                                'SELECT_DELIVERY_SUPPLIER_MODAL.LOCKED_RESELLER_INFO'
                                            }
                                        />
                                    ) : (
                                        <LocalizedMessage
                                            id={
                                                'SELECT_DELIVERY_SUPPLIER_MODAL.LOCKED_WHOLESALER_INFO'
                                            }
                                        />
                                    )}
                                </span>
                            )}
                            {/*
                                <a href="/account/details" className="button-link-plain button-link-plain--small button-link-plain--main">
                                    {memberType == 'retail-customer' ?
                                        <LocalizedMessage id={'SELECT_DELIVERY_SUPPLIER_MODAL.ADD_NEW_RESELLER'} />
                                        :
                                        <LocalizedMessage id={'SELECT_DELIVERY_SUPPLIER_MODAL.ADD_NEW_WHOLESALER'} />
                                    }
                                </a>
                            */}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

// default props
SupplierSection.defaultProps = {
    fieldRefs: null,
    updateField: () => {},
    handleFormUpdate: () => {},
    formData: {},
    isLoading: {},
    addresses: [],
};
// validate props
SupplierSection.propTypes = {
    fieldRefs: PropTypes.any.isRequired,
    updateField: PropTypes.func.isRequired,
    handleFormUpdate: PropTypes.func.isRequired,
    formData: PropTypes.any.isRequired,
    isLoading: PropTypes.any.isRequired,
    addresses: PropTypes.any.isRequired,
    memberType: PropTypes.string.isRequired,
};

export default SupplierSection;
